// Two drawings for the architects page:
//   PipeBundleDiagram  a section through the pipe pair to one indoor unit
//   VrvInstallDiagram  a building section with the numbered installation checks
// Plain SVG, so they stay sharp on any screen.

const L = { fontSize: 9, fontWeight: 700, fill: '#475569' };
const O = '#c2410c';

// Drawn to scale (2.2 px per mm): liquid 9.5 mm + 13 mm insulation, gas
// 15.9 mm + 19 mm insulation, side by side, with the communication cable.
export function PipeBundleDiagram() {
  return (
    <svg viewBox="0 0 360 200" className="block h-auto w-full" role="img"
      aria-label="Section through the pipe pair to one indoor unit of 2 to 4.6 tons: liquid pipe 9.5 mm with 13 mm insulation and gas pipe 15.9 mm with 19 mm insulation, side by side and taped together with the communication cable. About 90 mm (3.5 inches) wide and 55 mm (2 inches) deep.">
      <rect x="40" y="150" width="232" height="9" rx="1" fill="#94a3b8" />
      <circle cx="89" cy="111" r="39" fill="#1f2937" />
      <circle cx="89" cy="111" r="10.5" fill={O} />
      <circle cx="187.4" cy="90.7" r="59.3" fill="#1f2937" />
      <circle cx="187.4" cy="90.7" r="17.5" fill={O} />
      <circle cx="132" cy="141" r="8" fill="#fde68a" stroke="#92400e" strokeWidth="1.5" />
      <line x1="50" y1="22" x2="246.7" y2="22" stroke={O} strokeWidth="1.5" />
      <line x1="50" y1="16" x2="50" y2="28" stroke={O} strokeWidth="1.5" />
      <line x1="246.7" y1="16" x2="246.7" y2="28" stroke={O} strokeWidth="1.5" />
      <text x="148" y="14" textAnchor="middle" fontSize="12" fontWeight="800" fill={O}>about 90 mm (3½ in)</text>
      <line x1="262" y1="31.4" x2="262" y2="150" stroke={O} strokeWidth="1.5" />
      <line x1="256" y1="31.4" x2="268" y2="31.4" stroke={O} strokeWidth="1.5" />
      <line x1="256" y1="150" x2="268" y2="150" stroke={O} strokeWidth="1.5" />
      <text x="272" y="84" fontSize="12" fontWeight="800" fill={O}>about</text>
      <text x="272" y="99" fontSize="12" fontWeight="800" fill={O}>55 mm</text>
      <text x="272" y="114" fontSize="12" fontWeight="800" fill={O}>(2 in)</text>
      <text x="89" y="176" textAnchor="middle" {...L}>LIQUID 9.5 mm</text>
      <text x="89" y="189" textAnchor="middle" fontSize="9" fill="#64748b">13 mm insulation</text>
      <text x="143" y="176" textAnchor="middle" {...L}>CABLE</text>
      <text x="200" y="176" textAnchor="middle" {...L}>GAS 15.9 mm</text>
      <text x="200" y="189" textAnchor="middle" fontSize="9" fill="#64748b">19 mm insulation</text>
    </svg>
  );
}

function Mark({ x, y, n }) {
  return (
    <g>
      <circle cx={x} cy={y} r="10" fill={O} />
      <text x={x} y={y + 4} textAnchor="middle" fontSize={n > 9 ? 10 : 11} fontWeight="800" fill="#ffffff">{n}</text>
    </g>
  );
}

export function VrvInstallDiagram() {
  return (
    <svg viewBox="0 0 360 300" className="block h-auto w-full" role="img"
      aria-label="Section through a building: the outdoor unit on a raised base on the terrace, pipes in a covered tray, down a shaft and along the false ceiling to a REFNET joint, then to a ducted unit and a cassette, with drains falling to a drain stack. Numbers mark the checks listed below.">
      <text x="78" y="18" textAnchor="middle" {...L}>OUTDOOR UNIT</text>
      <text x="200" y="40" textAnchor="middle" {...L}>TERRACE</text>
      <path d="M124 88 L276 88 L276 150 L210 150" stroke="#1f2937" strokeWidth="5" fill="none" />
      <path d="M124 93 L288 93 L288 158 L210 158" stroke="#1f2937" strokeWidth="3.5" fill="none" />
      <path d="M191 150 L128 150" stroke="#1f2937" strokeWidth="5" fill="none" />
      <path d="M191 158 L128 158" stroke="#1f2937" strokeWidth="3.5" fill="none" />
      <path d="M200 163 L200 176" stroke="#1f2937" strokeWidth="5" fill="none" />
      <rect x="0" y="110" width="360" height="12" fill="#e5e7eb" />
      <path d="M30 122L40 110M60 122L70 110M90 122L100 110M150 122L160 110M180 122L190 110M210 122L220 110M240 122L250 110M300 122L310 110M330 122L340 110" stroke="#cbd5e1" strokeWidth="1.5" />
      <rect x="270" y="110" width="26" height="12" fill="#ffffff" stroke="#94a3b8" strokeDasharray="3 2" />
      <rect x="28" y="98" width="100" height="12" fill="#94a3b8" />
      <rect x="38" y="94" width="12" height="4" fill="#334155" />
      <rect x="106" y="94" width="12" height="4" fill="#334155" />
      <rect x="32" y="34" width="92" height="60" rx="3" fill="#f8fafc" stroke="#334155" strokeWidth="2" />
      <ellipse cx="78" cy="34" rx="34" ry="5" fill="#cbd5e1" stroke="#334155" strokeWidth="1.5" />
      <path d="M40 52H116M40 62H116M40 72H116M40 82H116" stroke="#cbd5e1" strokeWidth="1.5" />
      <rect x="122" y="80" width="156" height="4" fill="#64748b" />
      <rect x="124" y="84" width="152" height="12" fill="#cbd5e1" stroke="#64748b" strokeWidth="1" />
      <text x="314" y="160" textAnchor="middle" {...L} transform="rotate(-90 314 160)">SHAFT</text>
      <line x1="60" y1="122" x2="60" y2="140" stroke="#64748b" strokeWidth="2" />
      <line x1="116" y1="122" x2="116" y2="140" stroke="#64748b" strokeWidth="2" />
      <rect x="48" y="140" width="80" height="26" rx="3" fill="#dbeafe" stroke="#1d4ed8" strokeWidth="2" />
      <text x="88" y="157" textAnchor="middle" fontSize="9" fontWeight="700" fill="#1e3a8a">DUCTED</text>
      <line x1="244" y1="122" x2="244" y2="162" stroke="#64748b" strokeWidth="2" />
      <rect x="234" y="161" width="20" height="4" fill="#475569" />
      <circle cx="200" cy="154" r="9" fill="#ffffff" stroke={O} strokeWidth="2" />
      <text x="200" y="158" textAnchor="middle" fontSize="10" fontWeight="800" fill={O}>Y</text>
      <rect x="176" y="176" width="48" height="24" rx="3" fill="#dbeafe" stroke="#1d4ed8" strokeWidth="2" />
      <rect x="8" y="122" width="10" height="168" fill="#e2e8f0" stroke="#94a3b8" />
      <path d="M48 164 L18 170" stroke="#2563eb" strokeWidth="2.5" strokeDasharray="5 3" fill="none" />
      <path d="M176 186 L18 196" stroke="#2563eb" strokeWidth="2.5" strokeDasharray="5 3" fill="none" />
      <text x="122" y="185" fontSize="10" fontWeight="800" fill="#2563eb">1:100</text>
      <rect x="0" y="200" width="360" height="5" fill="#94a3b8" />
      <rect x="100" y="200" width="24" height="5" fill="#1d4ed8" />
      <rect x="168" y="200" width="64" height="6" rx="2" fill="#ffffff" stroke="#1d4ed8" strokeWidth="2" />
      <text x="246" y="220" {...L}>FALSE CEILING</text>
      <line x1="112" y1="210" x2="124" y2="232" stroke="#2563eb" strokeWidth="2.5" strokeLinecap="round" />
      <line x1="170" y1="212" x2="150" y2="234" stroke="#2563eb" strokeWidth="2.5" strokeLinecap="round" />
      <line x1="230" y1="212" x2="250" y2="234" stroke="#2563eb" strokeWidth="2.5" strokeLinecap="round" />
      <text x="200" y="266" textAnchor="middle" fontSize="10" fontWeight="700" fill="#94a3b8">ROOM</text>
      <rect x="0" y="290" width="360" height="10" fill="#e5e7eb" />
      <Mark x={14} y={96} n={11} />
      <Mark x={200} y={66} n={6} />
      <Mark x={220} y={136} n={3} />
      <Mark x={258} y={140} n={4} />
      <Mark x={158} y={134} n={5} />
      <Mark x={40} y={186} n={10} />
    </svg>
  );
}
